import { useEffect } from 'react';

export function useErrorToast(error: string | null, clearError: () => void, toast: any) {
    useEffect(() => {
        if (error) {
            toast({
                className: 'bg-red-800 text-white rounded-2xl',
                title: error,
            });
            clearError();
        }
    }, [error, toast, clearError]);
}
